const INTERFACE_KV = {
  quantity: "quantity",
  cantidad: "quantity",
  quantidade: "quantity",
  type: "type",
  tipo: "type",
  speed: "speed",
  velocidad: "speed",
  velocidade: "speed",
  unit: "unit",
  unidad: "unit",
  unidade: "unit",
  context: "context",
  contexto: "context",
};

const KV_LINE =
  /^(quantity|type|speed|unit|context|cantidad|tipo|velocidad|unidad|contexto|quantidade|velocidade|unidade)\s*:\s*(.*)$/i;

const KEY_LABELS_ES = {
  quantity: "cantidad",
  type: "tipo",
  context: "contexto",
  speed: "velocidad",
  unit: "unidad",
  disk: "disco",
};

const KEY_LABELS_PT = {
  quantity: "quantidade",
  type: "tipo",
  context: "contexto",
  speed: "velocidade",
  unit: "unidade",
  disk: "disco",
};

const DISPLAY_ES = [
  ["10 Gigabit Ethernet", "Ethernet 10 Gigabit"],
  ["Gigabit Ethernet bypass", "Ethernet Gigabit bypass"],
  ["Gigabit Ethernet", "Ethernet Gigabit"],
  ["Physical appliance", "Equipo físico"],
  ["Virtual appliance", "Appliance virtual"],
  ["High availability implementation", "implementación de alta disponibilidad"],
  ["Management and maintenance", "gestión y mantenimiento"],
  ["HA operating mode", "modo de operación HA"],
  ["Advanced bot mitigation", "Mitigación avanzada de bots"],
  ["active/active", "activo/activo"],
  ["active/passive", "activo/pasivo"],
  ["Console", "Consola"],
  ["Maintenance", "Mantenimiento"],
];

const DISPLAY_PT = [
  ["10 Gigabit Ethernet", "Ethernet 10 Gigabit"],
  ["Gigabit Ethernet bypass", "Ethernet Gigabit bypass"],
  ["Gigabit Ethernet", "Ethernet Gigabit"],
  ["Physical appliance", "Appliance físico"],
  ["Virtual appliance", "Appliance virtual"],
  ["High availability implementation", "implementação de alta disponibilidade"],
  ["Management and maintenance", "gestão e manutenção"],
  ["HA operating mode", "modo de operação HA"],
  ["Advanced bot mitigation", "Mitigação avançada de bots"],
  ["active/active", "ativo/ativo"],
  ["active/passive", "ativo/passivo"],
  ["Maintenance", "Manutenção"],
];

const CANONICAL = [
  ["modo de operación de alta disponibilidad", "ha_operating_mode"],
  ["modo de operacion de alta disponibilidad", "ha_operating_mode"],
  ["management and maintenance", "management_and_maintenance"],
  ["gestión y mantenimiento", "management_and_maintenance"],
  ["gestion y mantenimiento", "management_and_maintenance"],
  ["high availability implementation", "ha_implementation"],
  ["implementación de alta disponibilidad", "ha_implementation"],
  ["implementacion de alta disponibilidad", "ha_implementation"],
  ["advanced bot mitigation", "advanced_bot_mitigation"],
  ["mitigación avanzada de bots", "advanced_bot_mitigation"],
  ["mitigacion avanzada de bots", "advanced_bot_mitigation"],
  ["10 gigabit ethernet", "10_gigabit_ethernet"],
  ["ethernet 10 gigabit", "10_gigabit_ethernet"],
  ["gigabit ethernet bypass", "gigabit_ethernet_bypass"],
  ["ethernet gigabit bypass", "gigabit_ethernet_bypass"],
  ["gigabit ethernet", "gigabit_ethernet"],
  ["ethernet gigabit", "gigabit_ethernet"],
  ["physical appliance", "physical_appliance"],
  ["equipo físico", "physical_appliance"],
  ["equipo fisico", "physical_appliance"],
  ["virtual appliance", "virtual_appliance"],
  ["appliance virtual", "virtual_appliance"],
  ["ha operating mode", "ha_operating_mode"],
  ["modo de operación ha", "ha_operating_mode"],
  ["modo de operacion ha", "ha_operating_mode"],
  ["active/active", "active_active"],
  ["activo/activo", "active_active"],
  ["active/passive", "active_passive"],
  ["activo/pasivo", "active_passive"],
  ["maintenance", "maintenance"],
  ["mantenimiento", "maintenance"],
  ["console", "console"],
  ["consola", "console"],
  ["gestao e manutencao", "management_and_maintenance"],
  ["gestão e manutenção", "management_and_maintenance"],
  ["implementação de alta disponibilidade", "ha_implementation"],
  ["implementacao de alta disponibilidade", "ha_implementation"],
  ["mitigação avançada de bots", "advanced_bot_mitigation"],
  ["mitigacao avancada de bots", "advanced_bot_mitigation"],
  ["appliance físico", "physical_appliance"],
  ["appliance fisico", "physical_appliance"],
  ["modo de operação ha", "ha_operating_mode"],
  ["modo de operacao ha", "ha_operating_mode"],
  ["ativo/ativo", "active_active"],
  ["ativo/passivo", "active_passive"],
  ["manutenção", "maintenance"],
  ["manutencao", "maintenance"],
].sort((left, right) => right[0].length - left[0].length);

function formatNumber(value) {
  if (typeof value === "boolean" || (typeof value !== "number" && typeof value !== "bigint")) {
    return String(value);
  }
  const number = Number.isInteger(value) ? value : value;
  if (Number.isFinite(number) && Math.abs(number) >= 1000 && Number.isInteger(number)) {
    return number.toLocaleString("en-US");
  }
  return String(value);
}

function parseNumber(value) {
  if (typeof value === "number" || typeof value === "boolean") return value;
  const text = String(value || "").trim().replace(/,/g, "");
  if (!text) return value;
  const number = Number(text);
  if (!Number.isFinite(number)) return value;
  return Number.isInteger(number) ? number : number;
}

function isPowerSupplyShape(value) {
  const keys = Object.keys(value);
  return (
    keys.some((key) => key === "redundant" || key === "feed") &&
    !keys.includes("feature") &&
    !Object.prototype.hasOwnProperty.call(value, "value")
  );
}

function isMeasurement(value) {
  return Object.prototype.hasOwnProperty.call(value, "value") && value.status == null && value.evidence_row_ids == null;
}

function isInterfaceShape(value) {
  const keys = Object.keys(value);
  if (keys.some((key) => key === "redundant" || key === "feed" || key === "feature")) return false;
  if (value.status != null || value.evidence_row_ids != null) return false;
  if (Object.prototype.hasOwnProperty.call(value, "value") && value.type == null) return false;
  return (
    keys.some((key) => key === "type" || key === "quantity") &&
    keys.some((key) => ["quantity", "type", "speed", "context", "unit"].includes(key))
  );
}

export function localizeDisplayText(text, language) {
  const mapping = language === "es" ? DISPLAY_ES : language === "pt" ? DISPLAY_PT : null;
  if (!mapping || text == null || text === "") return text;
  let out = String(text);
  mapping.forEach(([source, target]) => {
    const escaped = source.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const pattern = source.length <= 12 ? new RegExp(`\\b${escaped}\\b`, "gi") : new RegExp(escaped, "gi");
    out = out.replace(pattern, target);
  });
  return out;
}

export function canonicalizeDisplayText(text) {
  let lowered = String(text || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
  if (!lowered) return "";
  CANONICAL.forEach(([source, token]) => {
    lowered = lowered.split(source).join(token);
  });
  return lowered;
}

function keyLabel(key, language) {
  if (language === "es" && KEY_LABELS_ES[key]) return KEY_LABELS_ES[key];
  if (language === "pt" && KEY_LABELS_PT[key]) return KEY_LABELS_PT[key];
  return String(key).replace(/_/g, " ");
}

function formatInterface(value, language) {
  const quantity = value.quantity;
  const speed = value.speed;
  const unit = String(value.unit || "").trim();
  const portType = String(value.type || "").trim();
  const context = localizeDisplayText(String(value.context || "").trim(), language);
  const parts = [];
  if (quantity != null && quantity !== "") parts.push(`${formatNumber(quantity)} ×`);
  let speedText = "";
  if (speed != null && speed !== "") speedText = `${formatNumber(speed)} ${unit}`.trim();
  else if (unit) speedText = unit;
  const middle = [speedText, portType].filter(Boolean).join(" ");
  if (middle) parts.push(middle);
  const line = parts.join(" ").trim();
  if (context) return line ? `${line} — ${context}` : context;
  return line || null;
}

function parseKvLine(text) {
  const match = String(text || "").trim().match(KV_LINE);
  if (!match) return null;
  return [INTERFACE_KV[match[1].toLowerCase()], match[2].trim()];
}

function portFromKv(port) {
  const out = {};
  if (port.quantity != null) out.quantity = parseNumber(port.quantity);
  if (port.speed != null) out.speed = parseNumber(port.speed);
  if (port.unit != null) out.unit = port.unit;
  if (port.type != null) out.type = port.type;
  if (port.context != null) out.context = port.context;
  return out;
}

function regroupExplodedInterfaces(items, language) {
  const parsed = items.map((item) => (typeof item === "string" ? parseKvLine(item) : null));
  if (parsed.filter(Boolean).length < 2) return null;
  const ports = [];
  let current = {};
  const flush = () => {
    if (!Object.keys(current).length) return;
    const formatted = formatInterface(portFromKv(current), language);
    if (formatted) ports.push(formatted);
    current = {};
  };
  items.forEach((item, index) => {
    const kv = parsed[index];
    if (!kv) {
      flush();
      const formatted = formatScopeDisplayValue(item, language);
      if (Array.isArray(formatted)) ports.push(...formatted.filter((part) => part != null && part !== ""));
      else if (formatted != null && formatted !== "") ports.push(String(formatted));
      return;
    }
    const [key, raw] = kv;
    if (Object.prototype.hasOwnProperty.call(current, key) || (key === "quantity" && Object.keys(current).length)) {
      flush();
    }
    current[key] = raw;
  });
  flush();
  return ports;
}

function canonicalFacts(value) {
  if (value == null || typeof value === "boolean") return value;
  if (typeof value === "number") return value;
  if (typeof value === "string") return canonicalizeDisplayText(value);
  if (Array.isArray(value)) return value.map((item) => canonicalFacts(item));
  if (typeof value === "object") {
    if (isInterfaceShape(value)) {
      return [
        parseNumber(value.quantity),
        value.speed == null || value.speed === "" ? null : parseNumber(value.speed),
        String(value.unit || "").trim().toLowerCase(),
        String(value.type || "").trim().toLowerCase(),
      ];
    }
    if (isMeasurement(value)) return canonicalFacts(value.value);
    return Object.keys(value)
      .filter((key) => key !== "pages" && key !== "page" && key !== "evidence" && key !== "context")
      .sort()
      .map((key) => [key, canonicalFacts(value[key])]);
  }
  return canonicalizeDisplayText(value);
}

function factsEqual(left, right) {
  return JSON.stringify(left) === JSON.stringify(right);
}

export function isLanguageRestatement(approved, detected) {
  if (approved == null || approved === "" || (Array.isArray(approved) && !approved.length)) return false;
  if (detected == null || detected === "" || (Array.isArray(detected) && !detected.length)) return false;
  const left = canonicalFacts(approved);
  const right = canonicalFacts(detected);
  if (left == null || left === "" || (Array.isArray(left) && !left.length)) return false;
  return factsEqual(left, right);
}

export function formatScopeDisplayValue(value, language = "en") {
  if (value == null || typeof value === "boolean") return value;
  if (typeof value === "string") return localizeDisplayText(value, language);
  if (typeof value === "number") {
    return Number.isFinite(value) && Math.abs(value) >= 1000 ? value.toLocaleString("en-US") : value;
  }
  if (Array.isArray(value)) {
    const regrouped = regroupExplodedInterfaces(value, language);
    if (regrouped) return regrouped;
    return value
      .map((item) => formatScopeDisplayValue(item, language))
      .flatMap((item) => (Array.isArray(item) ? item : [item]))
      .filter((item) => item != null && item !== "")
      .map((item) => (typeof item === "object" ? JSON.stringify(item) : String(item)));
  }
  if (typeof value !== "object") return localizeDisplayText(String(value), language);
  if (isPowerSupplyShape(value)) return value;
  if (isInterfaceShape(value)) return formatInterface(value, language);
  if (value.feature) {
    const feature = localizeDisplayText(value.feature, language);
    return value.context ? `${feature} — ${localizeDisplayText(value.context, language)}` : feature;
  }
  if (isMeasurement(value)) {
    const inner = typeof value.value === "object" ? formatScopeDisplayValue(value.value, language) : value.value;
    const amount = inner == null || inner === "" ? "" : String(inner);
    const localizedAmount = localizeDisplayText(amount, language);
    const withUnit = value.unit ? `${localizedAmount} ${value.unit}`.trim() : localizedAmount;
    const context = localizeDisplayText(value.context || "", language);
    return context ? `${withUnit} (${context})`.trim() : withUnit;
  }
  const lines = Object.entries(value)
    .filter(([key]) => key !== "pages" && key !== "page" && key !== "evidence")
    .map(([key, child]) => {
      const formatted = formatScopeDisplayValue(child, language);
      if (formatted == null || formatted === "" || (Array.isArray(formatted) && !formatted.length)) return null;
      const label = keyLabel(key, language);
      if (Array.isArray(formatted)) return `${label}: ${formatted.join("; ")}`;
      if (typeof formatted === "object") return null;
      return `${label}: ${formatted}`;
    })
    .filter(Boolean);
  if (!lines.length) return null;
  return lines.length === 1 ? lines[0] : lines;
}

export function flattenScopeFieldResult(fieldId, result, language = "en") {
  if (!result || typeof result !== "object") return result;
  if (String(fieldId || "").endsWith(".power_supply")) return result;
  return { ...result, value: formatScopeDisplayValue(result.value, language) };
}
